// RichTextEditor.jsx
import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const RichTextEditor = ({ value, onChange, placeholder = "Write something..." }) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    placeholder,
    toolbarAdaptive: false,
    toolbarSticky: false,
    showCharsCounter: false,
    showWordsCounter: false,
    allowInlineStyles: true,
    showXPathInStatusbar: false,
    useClasses: false,
    enter: "DIV",
    cleanHTML: {
      fillEmptyParagraph: false,
      removeEmptyElements: false,
      removeEmptyAttributes: true,
      removeAttributes: ["class"],
    },
    pasteHTMLAction: "insert_clear",
    pasteRemoveStyles: false,
    pasteRemoveClasses: true,
    buttons: [
      "bold","italic","underline","strikethrough","|",
      "font","fontsize","brush","|",
      "ul","ol","outdent","indent","|",
      "align","link","image","table","|",
      "undo","redo","eraser"
    ],
  };

  return (
    <div className="border border-neutral-300 rounded overflow-hidden">
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        onBlur={newContent => onChange(newContent)}
      />
    </div>
  );
};

export default RichTextEditor;